export default __webpack_public_path__ + "static/media/WAS0333.34I-41666_-24932_0.e48a73c2.jpg";